import { useGetSolPriceUsd } from '@/hooks/services/useTokenPrice'

const useHelper = () => {
  useGetSolPriceUsd()
}

export default useHelper
